module.exports = __webpack_public_path__ + "img/img-3.fee781d3.png";